/** The "Preferred B2B Chains" Setting, parsed. Pure: shared by the Settings
 *  validator (client + server) and the bots' matcher (server/mogbot). */

/** The entered chain names: comma, semicolon or newline separated. */
export const parsePreferredChains = (text: string | null | undefined): string[] =>
  (text ?? '').split(/[,;\n]+/).map((s) => s.trim()).filter(Boolean);

export const PREFERRED_CHAIN_MIN_LENGTH = 3;

export const validatePreferredChains = (value: unknown): string | null => {
  if (value === undefined || value === null || value === '') return null;
  if (typeof value !== 'string') return 'Must be a comma-separated list of chain names';
  const short = parsePreferredChains(value).filter((n) => n.length < PREFERRED_CHAIN_MIN_LENGTH);
  return short.length ? `Each name needs at least ${PREFERRED_CHAIN_MIN_LENGTH} characters: ${short.join(', ')}` : null;
};
